// Utils/axiosSetup.js
// Anti-tampering: Validates payment status on all API responses
import axios from 'axios';
import { toast } from 'react-toastify';

let isPaymentCheckActive = false;

const setupAxiosInterceptors = () => {
  // Response interceptor to check payment status
  axios.interceptors.response.use(
    (response) => {
      // Check for payment-related headers or response flags
      if (response.headers['x-payment-required'] === 'true' || 
          response.data?.requiresPayment === true) {
        if (!isPaymentCheckActive) {
          isPaymentCheckActive = true;
          toast.error('Payment required to continue');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
      return response;
    },
    (error) => {
      // Handle 402 Payment Required or 403 with payment message
      if (error.response?.status === 402 || 
          (error.response?.status === 403 && 
           error.response?.data?.message?.toLowerCase().includes('payment'))) {
        if (!isPaymentCheckActive) {
          isPaymentCheckActive = true;
          toast.error('Payment required to access this feature');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
      return Promise.reject(error);
    }
  );

  // Request interceptor to add payment verification
  axios.interceptors.request.use(
    (config) => {
      // Add a header to indicate frontend payment check passed
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['X-Frontend-Payment-Verified'] = 'true';
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
